export class InviteUser {
	email: string;

	constructor() {
	  this.email = '';
	}
 }
